// extracted by mini-css-extract-plugin
export default {"root":"_31mTh","expanded":"_2Ilss"};